module.exports = __webpack_public_path__ + "img/category-fishing-game.29af7db8.png";